/**
 * Features that are switched off for now.
 *
 * A switched-off feature stays on screen, disabled, so people see what Glossa will do instead of
 * wondering where a control went.
 *
 * AI is off until a provider (Azure OpenAI or DeepL) is configured in every environment — the API
 * answers 503 without one anyway. Turning it back on is this flag plus the AI jobs route in
 * `App.tsx` and its guide in `help/registry.ts`.
 */
export const AI_ENABLED = false;

/** Tooltip on every disabled AI control. */
export const AI_DISABLED_REASON = 'AI translation is not available yet';
